import { default as _91id_93rHyqX4xQzaMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/appointment/[id].vue?macro=true";
import { default as appointmentzBbhdyTFstMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/appointment.vue?macro=true";
import { default as _91id_93nVmjvmE3U8Meta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/event/[id].vue?macro=true";
import { default as eventHrxc6cXFP2Meta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/event.vue?macro=true";
import { default as eventIFrame7CZn47EMSnMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/eventIFrame.vue?macro=true";
import { default as eventIFramePreviewidXGat9sIjMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/eventIFramePreview.vue?macro=true";
import { default as eventIFrameTestFsRGYThrd2Meta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/eventIFrameTest.vue?macro=true";
import { default as indexoHCTvIcaRSMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/index.vue?macro=true";
import { default as _91registration_9337Du8Vn8eBMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/overview/[registration].vue?macro=true";
import { default as overviewh3X5k9YHdVMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/overview.vue?macro=true";
import { default as participantsVEjS3aiznFMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/participants.vue?macro=true";
import { default as participantsDetailsWjRlW0w9BCMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/participantsDetails.vue?macro=true";
import { default as payment5YyMw5isZBMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/payment.vue?macro=true";
import { default as registrationDetails6S3OTSwfCqMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/registrationDetails.vue?macro=true";
import { default as regStart4HECveAziBMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/regStart.vue?macro=true";
import { default as regSummarya8jpVSp2EMMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/regSummary.vue?macro=true";
import { default as _91id_93IjwzThzY05Meta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id].vue?macro=true";
import { default as registrationiFHfE9LZ6kMeta } from "/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration.vue?macro=true";
export default [
  {
    name: "appointment___de",
    path: "/appointment",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/appointment.vue").then(m => m.default || m),
    children: [
  {
    name: "appointment-id___de",
    path: "/termin/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/appointment/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "appointment___en",
    path: "/en/appointment",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/appointment.vue").then(m => m.default || m),
    children: [
  {
    name: "appointment-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/appointment/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "event___de",
    path: "/event",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/event.vue").then(m => m.default || m),
    children: [
  {
    name: "event-id___de",
    path: "/veranstaltung/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/event/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "event___en",
    path: "/en/event",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/event.vue").then(m => m.default || m),
    children: [
  {
    name: "event-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/event/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "eventIFrame___de",
    path: "/eventIFrame",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/eventIFrame.vue").then(m => m.default || m)
  },
  {
    name: "eventIFrame___en",
    path: "/en/eventIFrame",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/eventIFrame.vue").then(m => m.default || m)
  },
  {
    name: "eventIFramePreview___de",
    path: "/eventIFramePreview",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/eventIFramePreview.vue").then(m => m.default || m)
  },
  {
    name: "eventIFramePreview___en",
    path: "/en/eventIFramePreview",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/eventIFramePreview.vue").then(m => m.default || m)
  },
  {
    name: "eventIFrameTest___de",
    path: "/eventIFrameTest",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/eventIFrameTest.vue").then(m => m.default || m)
  },
  {
    name: "eventIFrameTest___en",
    path: "/en/eventIFrameTest",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/eventIFrameTest.vue").then(m => m.default || m)
  },
  {
    name: "index___de",
    path: "/",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "overview___de",
    path: "/overview",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/overview.vue").then(m => m.default || m),
    children: [
  {
    name: "overview-registration___de",
    path: "/uebersicht/:registration()",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/overview/[registration].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "overview___en",
    path: "/en/overview",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/overview.vue").then(m => m.default || m),
    children: [
  {
    name: "overview-registration___en",
    path: ":registration()",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/overview/[registration].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "registration___de",
    path: "/registration",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration.vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id___de",
    path: "/anmeldung/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id-participants___de",
    path: "teilnehmer",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/participants.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-participantsDetails___de",
    path: "teilnehmerDetails",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/participantsDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-payment___de",
    path: "zahlung",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/payment.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-registrationDetails___de",
    path: "anmeldungsDetails",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/registrationDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regStart___de",
    path: "start",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/regStart.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regSummary___de",
    path: "zusammenfassung",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/regSummary.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: "registration___en",
    path: "/en/registration",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration.vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id-participants___en",
    path: "/en/registration/participants",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/participants.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-participantsDetails___en",
    path: "/en/registration/participantsDetails",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/participantsDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-payment___en",
    path: "/en/registration/payment",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/payment.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-registrationDetails___en",
    path: "/en/registration/registrationDetails",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/registrationDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regStart___en",
    path: "/en/registration/start",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/regStart.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regSummary___en",
    path: "/en/registration/summary",
    component: () => import("/home/forge/amosweb.de/releases/20250728075004/registration/pages/registration/[id]/regSummary.vue").then(m => m.default || m)
  }
]
  }
]
  }
]